import React from "react";
import "./QuoteSection.css";

function QuoteSection() {
  return (
    <div className="cyf_quote_section">
      <div className="container">
        <div className="cyf_quote_box">
          <div className="cyf_quote_mark">
            <img
              src="/assets/images/check_your_fit/banner/quote.png"
              className="banner_quote_img"
              alt="quote img"
            />
          </div>

          <p className="cyf_quote_text">
           Aspiring to a sustainable and respected entrepreneurial career in the education sector, one with enormous, unexploited growth potential? Becoming a Profcyma Partner is a strategic move to realize these ambitions."
          </p>
        </div>
      </div>
    </div>
  );
}

export default QuoteSection;
